import React from 'react'

interface Option {
  value: string
  label: string
}

interface SelectDropdownProps {
  options: Option[]
  placeholder?: string
  value?: string
  onChange: (value: string) => void
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
  options,
  placeholder = 'Select an option',
  value,
  onChange
}) => {
  return (
    <div className="relative mb-4">
      <select
        className="w-full p-3 rounded-lg appearance-none focus:outline-none border border-gray-300 dark:border-gray-600 bg-background dark:bg-background-dark text-text-primary dark:text-text-primary-dark"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-text-secondary dark:text-text-secondary-dark"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}

export default SelectDropdown
